import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';
import { CloudActions } from 'reactApp/constants/cloudActions';

export class NewSearchApiCall extends APICallV4 {
    _method = 'private/search';
    _type: Method = 'post';
    _headers = { 'X-VFS-Action': CloudActions.SEARCH };
}
